// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ks","header":"kt","title":"ku","subheader":"kv","formWrapper":"kw"};